import { Action } from "@ngrx/store";

export enum ActionTypes {
    UploadLogSuccess = "[Log] UploadLogSuccess",
    UploadLogFailure = "[Log] UploadFailure",
}

export interface devideLogInfo {
    uuid: string;
    isSuccess: boolean;
    filepath?: string;
    message?: any;
}
export class UploadLogSuccess implements Action {
    public readonly type = ActionTypes.UploadLogSuccess;
    constructor(public payload: devideLogInfo) {}
}
export class UploadLogFailure implements Action {
    public readonly type = ActionTypes.UploadLogFailure;
    constructor(public error?) {}
}
export type ClareLogActions = UploadLogSuccess | UploadLogFailure;
